/**
 * Please use sparingly.
 */

const id = name => name.toLocaleLowerCase().replaceAll(/\s+/g, '-')

const fromAxios = error => error.toJSON

export { id, fromAxios }
